import React from "react";
import { Button, CardActions, FontIcon } from "react-md";
import { Field, reduxForm } from "redux-form";
import ReactMDTextField from "../../../common/components/ReactMDTextField";
import { required } from "../../../common/validators";
import ReactMDSelectField from "../../../common/components/ReactMDSelectField";
import { countries } from "../../../common/utils";
import FormInputIcon from "../../../common/components/FormInputIcon";

const countriesWithOther = countries.concat("Other");

const AddressForm = ({ handleSubmit, invalid, submitting }) => (
  <div>
    <section className="md-grid">
      <FormInputIcon>place</FormInputIcon>
      <Field
        id="country"
        name="country"
        label="Country"
        placeholder="Select a Country"
        helpOnFocus
        helpText="Please select a Country"
        className="md-cell md-cell--12 md-cell--with-icon"
        menuItems={countriesWithOther}
        required
        component={ReactMDSelectField}
        validate={[required]}
      />
      <Field
        label="Address"
        id="address"
        name="address"
        type="text"
        className="md-cell md-cell--12"
        required
        component={ReactMDTextField}
        validate={[required]}
        leftIcon={<FontIcon>home</FontIcon>}
      />
      <Field
        label="Address 2"
        id="address2"
        name="address2"
        type="text"
        className="md-cell md-cell--12"
        component={ReactMDTextField}
        leftIcon={<FontIcon>home</FontIcon>}
      />
      <Field
        id="city"
        name="city"
        label="City"
        className="md-cell md-cell--6"
        required
        component={ReactMDTextField}
        validate={[required]}
        leftIcon={<FontIcon>location_city</FontIcon>}
      />
      <Field
        id="province"
        name="province"
        label="State / Province"
        className="md-cell md-cell--3"
        required
        component={ReactMDTextField}
        validate={[required]}
      />
      <Field
        id="postal"
        name="postal"
        label="Postal"
        className="md-cell md-cell--3"
        required
        component={ReactMDTextField}
        validate={[required]}
      />
    </section>
    <CardActions>
      <Button
        raised
        primary
        className="md-cell--right"
        disabled={submitting || invalid}
        onClick={handleSubmit}
      >
        Save & Continue
      </Button>
    </CardActions>
  </div>
);

AddressForm.propTypes = {};
AddressForm.defaultProps = {};

export default reduxForm({
  form: "address-form",
})(AddressForm);



// WEBPACK FOOTER //
// ./src/registration/components/Address/AddressForm.jsx